// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MenuCardColumnButton {\n\n    margin-top: .5em;\n}\n", ""]);
// Exports
module.exports = exports;
